import EntryList from './EntryList'

function Payable() {
    return <EntryList type="pagar" title="Contas a Pagar" />
}

export default Payable
